













import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api'

import Footer from './Footer.vue'
import { pageContentSize, pixelsPerInch } from '~/common/constants/datasheet'

export default defineComponent({
  components: {
    Footer,
  },
  props: {
    size: {
      type: String as () => 'a4' | 'letter',
      required: true,
    },
  },
  setup(props) {
    const datasheetComponent = ref()
    const datasheetComponentHeight = ref<number>()
    const contentHeightOfOnePage = pageContentSize[props.size].height * pixelsPerInch
    const padding = ref(0)

    onMounted(() => {
      window.addEventListener('load', function () {
        // Recalculate height of the main datasheet so that the footer is at the end of the page.
        // Wait for all CSS and fonts to load before the height is calculated.
        const datasheetContentHeight = datasheetComponent.value.offsetHeight
        const numberOfPages = Math.ceil(datasheetContentHeight / contentHeightOfOnePage)
        datasheetComponentHeight.value = numberOfPages * contentHeightOfOnePage
        padding.value = datasheetComponentHeight.value - datasheetContentHeight
      })
    })

    return {
      datasheetComponent,
      datasheetComponentHeight,
      padding,
    }
  },
})
